export default "__VITE_ASSET__cc77415e__"